// extracted by mini-css-extract-plugin
export default {"selectWrapper":"styles_selectWrapper__tiDdN"};